import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'animate.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './helpers/AuthContext'; // Assurez-vous du chemin correct

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Importer le CSS ici

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <AuthProvider>
      <App />
      <ToastContainer />
    </AuthProvider>
  </Router>
);
